<template>
  <el-main class="page-content-margin-unset">
    <div class="table-top dk-li">
      <el-input
        placeholder="请输入商品名称进行搜索"
        v-model="body.keyword"
        clearable
        class="input-with-select dk_input"/>
      <el-button
        type="primary"
        @click="search()">
        搜索
      </el-button>
      <el-button @click="event().clearKeyword()">重置</el-button>
      <div>
        <el-button
          type="primary"
          @click="event().toExportClick()">
          导出
        </el-button>
        <a
          ref="export"
          style="display:none"
          :href="url"/>
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      border
      :data="tableData">
      <el-table-column
        prop="product_no"
        label="商品编号"/>
      <el-table-column
        prop="priority"
        label="排序"/>
      <el-table-column
        prop="title"
        label="商品标题"/>
      <el-table-column
        prop="price"
        label="商品价格"/>
      <el-table-column
        prop="cart_data"
        label="加入购物车次数"/>
    </el-table>
    <!-- 分页组件 -->
    <div class="pagination-center">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="body.page_index"
        :page-size="body.page_size"
        layout="prev, pager, next"
        :total="total"/>
    </div>
  </el-main>
</template>

<script>
  import {getExportUrlStatistics, getProductData} from '../../api/statistics'
  import {exportApi, imgDomain} from '../../configs/env'
import timeChange from '../../mixins/time-change'
import { setId } from '../../jslib/set-id'

export default {
  mixins: [timeChange],
  data() {
    return {
      url: '',
      imgDomain,
      body: {
        keyword: '',
        type: 'cart_data',
        page_index: 1,
        page_size: 20,
      },
      times: [],
      total: 0,
      tableData: [
        {},
      ],
      activeName: 'all',
    };
  },

  components: {
  },
  created() {
    this.network().getProductData()
  },
  methods: {
    handleCurrentChange () {
      this.network().getProductData()
    },
    search() {
      this.network().getProductData()
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    event() {
      return {
        clearKeyword: () => {
          this.body.keyword = ''
        },
        toExportClick: () => {
          this.network().getExportUrl()
        },
      }
    },
    network() {
      return {
        getProductData: async () => {
          const { status, data } = await getProductData(this.body)
          if (status !== 200) return
          this.tableData = setId(data.data, this.body.page_index, this.body.page_size)
          this.tableData = data.data
          this.total = data.total
        },
        getExportUrl: async () => {
          this.url = exportApi + '/v1/cms/Statistics/export?type=' + this.body.type + '&keyword=' + this.body.keyword
          this.$nextTick(() => {
            this.$refs.export.click()
          })
        },
      }
    },
    handler() {
      return {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/mixins.scss';
.table-top{
  @include dk-table-top;
}
</style>



// WEBPACK FOOTER //
// src/vuepage/statistics/shop-cart.vue